import React from 'react'
import { Flex } from '@chakra-ui/core'
import { BaseModalV2, Button, CloseButton } from 'components/ui'
import useLocaleText from 'components/useLocaleText'
import { DashboardReviewModal } from 'components/TasksV2/TasksOverview/components/DashboardReview'
import { ExecutionModalSkeleton } from 'components/TasksV2/TasksOverview/components/DashboardReview/ExecutionSkeleton'
import { reviewLiterals } from 'components/TasksV2/TasksOverview/components/DashboardReview/literals'
import { useExecutionText } from 'components/TasksV2/TasksOverview/hooks/useExecutionText'
import { useInsightsContext } from '../../InsightsStackProvider'
import { useMediaGalleryReview } from '../../hooks/useMediaGalleryReview'
import { MediaGalleryEntry } from '../../model/mediaGallery'

export function MediaGalleryReview({ entry, onClose }: { entry: MediaGalleryEntry; onClose: () => void }) {
  const { tid, recurrenceTs } = useInsightsContext()
  const { task, error, retry } = useMediaGalleryReview(tid, recurrenceTs, entry)
  const t = useLocaleText(reviewLiterals)
  const execution = useExecutionText()

  if (error) {
    return (
      <BaseModalV2
        floating
        isOpen
        onClose={onClose}
        header={<CloseButton onClick={onClose} />}
        body={
          <Flex role="alert" minH="320px" flexDirection="column" align="center" justify="center">
            {t.loadFailed}
            <Button variant="secondary" mt="16px" onClick={retry}>
              {execution.retry}
            </Button>
          </Flex>
        }
        footer={<></>}
      />
    )
  }

  if (!task) return <ExecutionModalSkeleton onClose={onClose} media />

  return (
    <DashboardReviewModal
      task={task}
      contexts={entry.contexts}
      initialFilter={{ mode: 'subtask', ids: entry.subtaskIds }}
      initialEntry={{ id: entry.subtaskId, media: true, mediaIndex: entry.mediaIndex }}
      onClose={onClose}
    />
  )
}
